import { useQuery } from "@tanstack/react-query";
import { getEditionCategoryInfo } from "src/api/editionCategory";
import { CATEGORY_STALE_TIME, QUERY_KEYS } from "../constants";
/**
 * 에디션 카테고리 정보(무료체험, 가이드배너 등)를 조회하는 훅
 * @param editionId - 에디션 ID
 */ export const useEditionCategoryInfo = (editionId)=>{
    return useQuery({
        queryKey: [
            QUERY_KEYS.EDITION_CATEGORY_INFO,
            editionId
        ],
        queryFn: ()=>getEditionCategoryInfo({
                editionId: editionId
            }),
        enabled: !!editionId && typeof editionId === "string",
        staleTime: CATEGORY_STALE_TIME,
        retry: 0
    });
};
